import { useEffect } from 'react';

import type { RootState } from '@app/store';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';

import {
	setMicVolume,
	setSelectedAudioInput,
	setSelectedAudioOutput,
	setSelectedVideoInput,
	setSpkVolume,
} from '../model/device-settings-slice';
import { useMediaDevices } from './use-media-devices';

export const useDeviceSettings = () => {
	const dispatch = useAppDispatch();
	const { selectedAudioInput, selectedVideoInput, selectedAudioOutput, micVolume, spkVolume } =
		useAppSelector((state: RootState) => state.deviceSettings);
	const { audioInputs, audioOutputs, videoInputs } = useMediaDevices();

	/** Обработчик изменения аудио устройства ввода */
	const handleAudioInputChange = (deviceId: string) => {
		dispatch(setSelectedAudioInput(deviceId));
	};

	/** Обработчик изменения видео устройства */
	const handleVideoInputChange = (deviceId: string) => {
		dispatch(setSelectedVideoInput(deviceId));
	};

	/** Обработчик изменения аудио устройства вывода */
	const handleAudioOutputChange = (deviceId: string) => {
		dispatch(setSelectedAudioOutput(deviceId));
	};

	/** Обработчик изменения микрофона */
	const handleMicVolumeChange = (value: number) => {
		dispatch(setMicVolume(value));
	};

	/** Обработчик изменения динамика */
	const handleSpeakerVolumeChange = (value: number) => {
		dispatch(setSpkVolume(value));
	};

	useEffect(() => {
		if (!selectedAudioInput && audioInputs.length > 0) {
			dispatch(setSelectedAudioInput(audioInputs[0].deviceId));
		}
	}, [audioInputs, selectedAudioInput, dispatch]);

	useEffect(() => {
		if (!selectedVideoInput && videoInputs.length > 0) {
			dispatch(setSelectedVideoInput(videoInputs[0].deviceId));
		}
	}, [videoInputs, selectedVideoInput, dispatch]);

	useEffect(() => {
		if (!selectedAudioOutput && audioOutputs.length > 0) {
			dispatch(setSelectedAudioOutput(audioOutputs[0].deviceId));
		}
	}, [audioOutputs, selectedAudioOutput, dispatch]);

	return {
		selectedAudioInput,
		selectedVideoInput,
		selectedAudioOutput,
		micVolume,
		spkVolume,
		handleAudioInputChange,
		handleVideoInputChange,
		handleAudioOutputChange,
		handleMicVolumeChange,
		handleSpeakerVolumeChange,
	};
};
